import React from 'react';
import DataProfileList from '../shared/DataProfileList';
import { SearchLayout } from './Layout';
import data from "../../../../assets/apiRoutes.json";
import { RateScheduleProfileRoutes } from '../../../../const/constants';

// Find screen for the Delphi form uWMD0005 "WM Rate Schedules Profile Entry" (browse of
// WMRATESCHEDULEDP). The listing itself is the shared DataProfileList; this file only supplies what
// is specific to the screen.

// One key per SearchLayout field, hidden ones included, so Reset can clear every one of them.
const initialFormFields = {
    recordNumber: '',
    profileCode: '',
    description: '',
    userDefinedCode1: '',
    userDefinedCode2: '',
    userDefinedCode3: '',
    userDefinedCode4: '',
    userDefinedCode5: ''
};

const List = () => (
    <DataProfileList
        gridKey="08C49455-67A8-4FB1-A405-FF534AEA3057"
        loadUrl={data.RateScheduleDp.GetRateScheduleDps}
        createRoute={RateScheduleProfileRoutes.Create}
        editRoute={RateScheduleProfileRoutes.Edit}
        title="Enter Your Query For Rate Schedule Profiles"
        searchLayout={SearchLayout}
        searchLayoutId="3D52C5C6-89F4-452E-B444-3F5C8B4F2FCB"
        searchLayoutName="WMRateScheduleProfileSearchForm"
        initialFormFields={initialFormFields}
        // PROFILECODE's DisplayLabel in uWMM0005.dfm is "Profile" - the form label differs.
        profileCaption="Profile"
    />
);

export default List;
